import styled from '@emotion/styled';

export const FlexBottomWrapper = styled.div<{
  isMobileLandscape?: boolean;
  isDisableHelpers?: boolean;
  isDrawerOpen?: boolean;
}>`
  position: fixed;
  bottom: ${({ isDrawerOpen, isDisableHelpers, isMobileLandscape }) =>
    isDrawerOpen && isDisableHelpers
      ? '160px'
      : isDrawerOpen && !isDisableHelpers
      ? '200px'
      : isDisableHelpers
      ? '30px'
      : isMobileLandscape
      ? '100px'
      : '70px'};
  display: flex;
  width: 100%;
  align-items: center;

  /* 전폭 스트립이 슬라이드 터치를 가로채지 않도록 버튼에만 이벤트를 허용한다 */
  pointer-events: none;
`;
